import EnableCookies from './EnableCookies';

export default EnableCookies;
